// Workspace (26/08): Mapas (canvas estilo Miro) e Drive (arquivos da conta).
// Tarefas segue nas próprias rotas (tasks.routes.js) — o menu agrupa os três.
import { frontendURL } from 'dashboard/helper/URLHelper';
import PlanningMapsIndex from './pages/PlanningMapsIndex.vue';
import PlanningMapView from './pages/PlanningMapView.vue';
import DriveIndex from './pages/DriveIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/workspace/maps'),
    name: 'planning_maps_index',
    component: PlanningMapsIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL('accounts/:accountId/workspace/maps/:mapId'),
    name: 'planning_map_view',
    component: PlanningMapView,
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL('accounts/:accountId/workspace/drive'),
    name: 'workspace_drive_index',
    component: DriveIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
];
